import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";

const ProductCard = ({ product, onClick }) => {
  return (
    <Card className="product-card" onClick={onClick}>
      <div className="product-overlay">
        <div>
          {/* <p>Price: ${product.price.toFixed(2)}</p> */}
          <span>Order Now</span>
        </div>
      </div>
      <img
        src={product.image}
        alt={product.title}
        className="card-img-top"
        style={{
          width: "100%",
          height: "200px",
          objectFit: "contain",
          background: "#f8f8f8",
          borderRadius: "8px",
        }}
      />
      <CardBody>
        <CardTitle tag="h5">{product.title}</CardTitle>
      </CardBody>
      <style>
        {`
          .product-card {
            position: relative;
            overflow: hidden;
            text-align: center;
            cursor: pointer;
            border: 1px solid #ddd;
            border-radius: 8px;
            transition: transform 0.3s ease;
          }
          .product-card:hover {
            transform: scale(1.03);
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
          }
          .product-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            color: white;
            font-size: 1.2rem;
            opacity: 0;
            transition: opacity 0.3s ease-in-out;
          }
          .product-card:hover .product-overlay {
            opacity: 1;
          }
        `}
      </style>
    </Card>
  );
};

export default ProductCard;
